import translations from './hafnium.content'
import type { Metal } from './types'

const t = translations
const dir = '/mine-my-phone/images/metals/hafnium'

export const hafnium: Metal = {
  id: 27,
  slug: 'hafnium',
  name: t.name,
  symbol: 'Hf',
  // Processing facilities, not mines; coordinates geocoded from the sheet's place names.
  mines: [
    {
      name: 'Albany, hafnium processing facility (United States)',
      region: 'Albany',
      coordinates: [-123.11, 44.64],
    },
    {
      name: 'Jarrie, hafnium processing facility (France)',
      region: 'Jarrie',
      coordinates: [5.75, 45.09],
    },
    {
      name: 'Ogden, hafnium processing facility (United States)',
      region: 'Ogden',
      coordinates: [-111.97, 41.22],
    },
    {
      name: 'Glazov, hafnium processing facility (Russia)',
      region: 'Glazov',
      coordinates: [52.66, 58.14],
    },
  ],
  // Producing shares, not mine production — see the `**` footnote.
  countries: [
    { name: 'France', percent: 50 },
    { name: 'United States', percent: 45 },
    { name: 'Russia', percent: 3 },
  ],
  content: {
    smartphone: {
      quantityScore: 1,
      quantityLabel: t.smartphone.label,
      parts: ['electronics'],
    },
    whatItDoes: t.whatItDoes,
    extraction: t.extraction,
    quickFact: t.quickFact,
    impacts: {
      environmental: { severity: 1, ...t.impacts.environmental },
      human: { severity: 1, ...t.impacts.human },
      geopolitical: { severity: 2, ...t.impacts.geopolitical },
    },
    supplyRisk: { score: null, ...t.supplyRisk },
    recycling: { score: 1, ...t.recycling },
    footnotes: t.footnotes,
    photos: {
      hero: {
        src: `${dir}/01.jpg`,
        orientation: 'horizontal',
      },
      firstBento: [
        {
          src: `${dir}/02.jpg`,
          orientation: 'vertical',
        },
        {
          src: `${dir}/03.jpg`,
          orientation: 'vertical',
        },
      ],
    },
  },
}
